var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCrushedBoxes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2933 20.568L21.04 19.0747C20.1782 19.0782 19.3528 19.4221 18.7434 20.0315C18.134 20.6408 17.7902 21.4663 17.7867 22.328L19.12 26.6747L17.7867 29.7414L18.56 32.3547L17.7867 34.3547L20 36.408L17.7867 37.5547V41.768C17.7902 42.6298 18.134 43.4553 18.7434 44.0646C19.3528 44.674 20.1782 45.0179 21.04 45.0214H42.2933C43.1551 45.0179 43.9805 44.674 44.5899 44.0646C45.1993 43.4553 45.5431 42.6298 45.5467 41.768L46.2133 39.6614L45.3333 37.1014L44.7733 35.0747L45.52 33.7947V29.768L42.3466 28.728L45.52 27.3147V23.8214C45.5165 22.9596 45.1726 22.1341 44.5632 21.5248C43.9539 20.9154 43.1284 20.5715 42.2667 20.568H42.2933Z",
    fill: "#123660"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 4.0013C16.5348 4.0013 3.99988 16.538 3.99988 32.0002C3.99988 47.4623 16.5348 59.999 32 59.999C47.4652 59.999 60.0001 47.4623 60.0001 32.0002C60.0001 16.538 47.4652 4.0013 32 4.0013ZM0.00012207 32.0002C0.00012207 14.3252 14.3281 -0.000976562 32 -0.000976562C49.6719 -0.000976562 63.9999 14.3252 63.9999 32.0002C63.9999 49.6751 49.6719 64.0013 32 64.0013C14.3281 64.0013 0.00012207 49.6751 0.00012207 32.0002Z",
    fill: "#FF0033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1153 55.638L8.03793 11.286L10.8741 8.46387L54.9514 52.8159L52.1153 55.638Z",
    fill: "#FF0033"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrushedBoxes);
export default __webpack_public_path__ + "static/media/icon-crushed-boxes.5bcedfdca801b2f6ad4b284814d42b16.svg";
export { ForwardRef as ReactComponent };